import React from 'react';
import { trackEvent, BOOKING_THERAPY_URL, BOOKING_SCREENING_URL, EMAIL_ADDRESS } from '../lib/tracking';
import { optimizeImage } from '../lib/image';

export default function Coaching() {
  return (
    <div className="bg-[#ECEEF1]">
      {/* Hero */}
      <section className="py-16 sm:py-24 bg-white border-b border-[#D9DDE2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block">
                Erhverv · Mål, Værdier & Handling
              </span>
              <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#5A232E] tracking-tight leading-[1.12]">
                Coaching for ledere og virksomheder
              </h1>
              <p className="text-base sm:text-lg text-[#6c7480] leading-relaxed">
                Coaching hjælper dig og din organisation med at tydeliggøre mål og delmål, styrke lederskab og skabe bæredygtig handlekraft. Gennem professionel samtale afdækker vi ønsker, værdier og ressourcer, så du kan finde løsninger og styrke dine og dit teams evner.
              </p>
              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={BOOKING_THERAPY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent('cta_booking_click', { location: 'coaching_hero' })}
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-sm shadow-md transition-all no-break whitespace-nowrap"
                >
                  <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                  <span>Book coachingsamtale (60 min.)</span>
                </a>
                <a
                  href={BOOKING_SCREENING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#ECEEF1] text-[#5A232E] font-medium text-sm border border-[#D9DDE2] hover:bg-[#D9DDE2] transition-colors no-break whitespace-nowrap"
                >
                  <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                  <span>Gratis afklaring (20 min.)</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white bg-[#D9DDE2]">
                <img
                  src={optimizeImage('kim-outdoor-park-1.webp', 800)}
                  alt="Kim Palasz - Coaching for ledere og virksomheder"
                  className="w-full h-auto object-cover max-h-[440px]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 sm:py-24 bg-[#ECEEF1]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl p-8 sm:p-12 border border-[#D9DDE2] shadow-xs space-y-6 text-[#11161d] leading-relaxed">
            <h2 className="font-display text-3xl text-[#5A232E]">
              Få redskaberne til selv at håndtere fremtidige udfordringer
            </h2>
            <p>
              Målet med coaching hos mig er at give dig konkrete redskaber til selv at håndtere fremtidige udfordringer med selvtillid, ro og klarhed.
            </p>
            <p>
              Gennem mine mange års erfaring med coaching af både ledere, medarbejdere i den finansielle sektor og private klienter, kombinerer jeg anerkendende spørgsmål, NLP-teknikker og praktiske øvelser, der skaber umiddelbar fremdrift.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="bg-[#ECEEF1] p-6 rounded-2xl border border-[#D9DDE2]">
                <h3 className="font-display text-lg text-[#5A232E] mb-2">Ledercoaching</h3>
                <p className="text-xs sm:text-sm text-[#6c7480] leading-relaxed">
                  Styrket kommunikation, assertiv feedback, håndtering af medarbejderudfordringer, personlig gennemslagskraft og forebyggelse af eget stressniveau.
                </p>
              </div>

              <div className="bg-[#ECEEF1] p-6 rounded-2xl border border-[#D9DDE2]">
                <h3 className="font-display text-lg text-[#5A232E] mb-2">Virksomhedscoaching & Teams</h3>
                <p className="text-xs sm:text-sm text-[#6c7480] leading-relaxed">
                  Målrettede forløb for nøglemedarbejdere og teams: balance mellem krav og ressourcer, forandringsprocesser og fælles retning.
                </p>
              </div>
            </div>

            <div className="p-4 rounded-xl bg-[#ECEEF1] border border-[#D9DDE2] text-xs text-[#5A232E] flex flex-wrap items-center justify-between gap-2 font-medium">
              <span>Varighed: 60 minutter pr. session</span>
              <span>Pris: 1.500 kr. (inkl. moms)</span>
              <span>Sted: Marengovej 2 på Amager eller online</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
